<button *ngIf="data.isVisible" draggable="true" (dragstart)="onDragStart($event)" mat-icon-button matTooltip="{{ data.tooltip }}">
	<mat-icon>{{ data.buttonIcon }}</mat-icon>
</button>
